import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`py-3 transition-all ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}
      variant={scrolled ? 'light' : 'light'}
    >
      <Container>
        <Navbar.Brand href="#home" className="fw-bold fs-4">
          Aditya Joshi
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#home" className="mx-2">Home</Nav.Link>
            <Nav.Link href="#about" className="mx-2">About</Nav.Link>
            <Nav.Link href="#skills" className="mx-2">Skills</Nav.Link>
            <Nav.Link href="#services" className="mx-2">Services</Nav.Link>
            <Nav.Link href="#projects" className="mx-2">Work</Nav.Link>
            <Nav.Link href="#contact" className="mx-2">
              <button className="btn btn-primary btn-sm">Hire Me</button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;